<template>
  <div class="g2e-main">
	<div class="g2e-sec1">
		<section class="g2e-sec1-header">
			<div>
				<span><img src="@img/g2e2017/section_logo1.png" alt=""></span>
				<span><img src="@img/g2e2017/section_logo2.png" alt=""></span>
			</div>
			<h1>{{$t('lang_2017Exhibition_banner_title')}}</h1>
			<h2>{{$t('lang_2017Exhibition_banner_subtitle')}}</h2>
		</section>
		<section class="g2e-sec1-content" v-html="$t('lang_2017Exhibition_banner_msg')"></section>
	</div>

	<div class="g2e-video">
		<div class="g2e-title_group">
			<div class="g2e-title_groupinner">
				<span class="g2e-title_group-icon"></span>
				<span class="g2e-title_grouptitle">
					<h1 v-html="$t('lang_themeHeading_onlineExhibition')"></h1>
					<h2>G2E Asia Video Tour</h2>
				</span>
			</div>
		</div>
		<div class="g2e-video-inner" onclick="fubo.gaEvent('hk_video','click')">
      <iframe style="width:100%;height:100%;" src="https://www.youtube.com/embed/g5Z25Xm2OxI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="isYoutube"></iframe>
			<div id="youkuplayer" style="width:100%;height:100%;" v-else></div>
		</div>
	</div>

	<div class="g2e-photo">
		<div class="g2e-title_group">
			<div class="g2e-title_groupinner">
				<span class="g2e-title_group-icon"></span>
				<span class="g2e-title_grouptitle">
					<h1 v-html="$t('lang_themeHeading_exhibitionHighlight')"></h1>
					<h2>Photo Gallery</h2>
				</span>
			</div>
		</div>
		<div class="g2e-photo-cover" v-if="!isMobile">
			<carousel
        ref="photoBannerCover"
        :perPage="1" 
        :mouse-drag="false" 
        :navigationEnabled="false" 
        :paginationEnabled="false" 
        :loop="true"
				:autoplay="true"
				:speed="1000"
				:autoplayTimeout="3000"
      >
				<slide v-for="(list,index) in banner" :key="index"><span class="g2e-photo-cover-info" v-html="$t(`${list.title}`)"></span><img :src="require(`@img/g2e2017/${list.pcImg}`)" alt=""></slide>
			</carousel>
      <a @click.prevent="prevSlide('photoBannerCover')" class="prev-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
      <a @click.prevent="nextSlide('photoBannerCover')" class="next-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
		</div>

		<div class="g2e-photo-preview" v-if="false">
			<carousel
        ref="photoBannerPreview"
        :perPageCustom="[[1366, 8],[1024, 6],[997, 4]]" 
        :mouse-drag="false" 
        :navigationEnabled="false" 
        :paginationEnabled="false" 
        :loop="true"
        :scrollPerPage="false"
      >
				<slide v-for="(list,index) in banner" :key="index"><img :src="require(`@img/g2e2017/${list.pcImg}`)" alt=""></slide>
			</carousel>
      <a @click.prevent="prevSlide('photoBannerPreview')" class="prev-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
      <a @click.prevent="nextSlide('photoBannerPreview')" class="next-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
		</div>

		<div class="g2e-photo-cover-mobile" v-if="isMobile">
			<carousel
        ref="mbPhotoBannerCover"
        :perPage="1" 
        :mouse-drag="false" 
        :navigationEnabled="false" 
        :paginationEnabled="false" 
        :loop="true"
				:autoplay="true"
				:speed="1000"
				:autoplayTimeout="3000"
      >
				<slide v-for="(list,index) in banner" :key="index"><span class="g2e-photo-cover-info" v-html="$t(`${list.title}`)"></span><img :src="require(`@img/mobile/g2e2017/${list.mbImg}`)" alt=""></slide>
			</carousel>
      <a @click.prevent="prevSlide('mbPhotoBannerCover')" class="prev-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
      <a @click.prevent="nextSlide('mbPhotoBannerCover')" class="next-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
		</div>

		<div class="g2e-photo-preview-mobile" v-if="false">
			<carousel
        ref="mbPhotoBannerPreview"
        :perPage="4"
        :mouse-drag="false" 
        :navigationEnabled="false" 
        :paginationEnabled="false" 
        :loop="true"
        :spacePadding="5"
      >
				<slide v-for="(list,index) in banner" :key="index"><img :src="require(`@img/mobile/g2e2017/${list.mbImg}`)" alt=""></slide>
			</carousel>
      <a @click.prevent="prevSlide('mbPhotoBannerPreview')" class="prev-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
      <a @click.prevent="nextSlide('mbPhotoBannerPreview')" class="next-btn">
        <img :src='require(`@img/develop/photoarrow.png`)'>
      </a>
		</div>
	</div>

	<div class="g2e-highlights">
		<div class="g2e-title_group">
			<div class="g2e-title_groupinner">
				<span class="g2e-title_group-icon"></span>
				<span class="g2e-title_grouptitle">
					<h1 v-html="$t('lang_themeHeading_exhibitionHeadline')"></h1>
					<h2>Product Highlights</h2>
				</span>
			</div>
		</div>

		<div class="g2e-highlights-inner">
			<div class="g2e-highlights-content">
				<h1>{{$t('lang_2017Headline_theme1_title')}}</h1>
				<h2>{{$t('lang_2017Headline_theme1_subtitle')}}</h2>
				<div class="g2e-highlights-msg" v-html="$t('lang_2017Headline_theme1_msg')"></div>
				<span class="g2e-highlights-btn" v-if="!isMobile"><router-link to="/payment" target="_blank">{{$t('lang_checkMore')}}</router-link></span>
				<div class="g2e-highlights-img" v-if="!isMobile"><img src="@img/g2e2017/highlight_1.png" alt=""></div>

				<div class="g2e-highlights-content-mobile" v-if="isMobile">
					<span class="g2e-highlights-btn"><router-link to="/payment" target="_blank">{{$t('lang_checkMore')}}</router-link></span>
					<div class="g2e-highlights-img"><img src="@img/mobile/g2e2017/highlight_1.png" alt=""></div>
				</div>
			</div>
			<div class="g2e-highlights-content">
				<h1>{{$t('lang_2017Headline_theme2_title')}}</h1>
				<h2>{{$t('lang_2017Headline_theme2_subtitle')}}</h2>
				<div class="g2e-highlights-img" v-if="!isMobile"><img src="@img/g2e2017/highlight_2.png" alt=""></div>
				<div class="g2e-highlights-msg" v-html="$t('lang_2017Headline_theme2_msg')"></div>
				<span class="g2e-highlights-btn" v-if="!isMobile"><router-link to="/rbcnsystem" target="_blank">{{$t('lang_checkMore')}}</router-link></span>

				<div class="g2e-highlights-content-mobile" v-if="isMobile">
					<span class="g2e-highlights-btn"><router-link to="/rbcnsystem" target="_blank">{{$t('lang_checkMore')}}</router-link></span>
					<div class="g2e-highlights-img"><img src="@img/mobile/g2e2017/highlight_2.png" alt=""></div>
				</div>
			</div>
			<div class="g2e-highlights-content">
				<div class="g2e-highlights-img" v-if="!isMobile"><img src="@img/g2e2017/highlight_3.png" alt=""></div>
				<h1>{{$t('lang_2017Headline_theme3_title')}}</h1>
				<h2>{{$t('lang_2017Headline_theme3_subtitle')}}</h2>
				<div class="g2e-highlights-msg" v-html="$t('lang_2017Headline_theme3_msg')"></div>
				<span class="g2e-highlights-btn" v-if="!isMobile"><router-link to="/develop" target="_blank">{{$t('lang_checkMore')}}</router-link></span>

				<div class="g2e-highlights-content-mobile" v-if="isMobile">
					<span class="g2e-highlights-btn"><router-link to="/develop" target="_blank">{{$t('lang_checkMore')}}</router-link></span>
					<div class="g2e-highlights-img"><img src="@img/mobile/g2e2017/highlight_3.png" alt=""></div>
				</div>
			</div>
		</div>

		<div class="g2e-combination" v-if="!isMobile">
			<div>
				<h1 v-html="$t('lang_mostCompetitive_title')"></h1>
				<h6 v-html="$t('lang_mostCompetitive_msg')"></h6>
				<span><router-link to="/platform/game" target="_blank">{{$t('lang_understandNow_platform')}}</router-link></span>
			</div
			><div>
				<img src="@img/g2e2017/pro_img.png" alt="">
			</div>
		</div>

		<div class="g2e-combination-mobile" v-else>
			<div>
				<h1 v-html="$t('lang_mostCompetitive_title')"></h1>
				<h6 v-html="$t('lang_mostCompetitive_mb_msg')"></h6>
				<span><router-link to="/platform/game" target="_blank">{{$t('lang_understandNow_platform')}}</router-link></span>
			</div
			><div>
				<img src="@img/mobile/g2e2017/pro_img.png" alt="">
			</div>
		</div>
	</div>
</div>
</template>

<script>
import $ from 'jquery'
import bannerData from '@data/g2e2017banner.json'
import { Carousel, Slide } from 'vue-carousel'
import {mapGetters} from 'vuex'

export default {
  name: 'G2EAsia2017',
  components: {
    Carousel,
    Slide
  },
  data(){
    return{
      banner:[],
      isMobile: false,
      deviceModel: 'pc',
      isYoutube: false,
    }
  },
  methods:{
    prevSlide: function(obj){
      this.$refs[obj].goToPage(this.$refs[obj].getPreviousPage());
    },
    nextSlide: function(obj){
      this.$refs[obj].goToPage(this.$refs[obj].getNextPage());
    },
    getDevice: function(){
      window.addEventListener('resize',this.windowRes)
      this.windowRes()
    },
    windowRes: function(){
      const $this = this
      if($this.deviceModel === 'mb' && $(window).width() > 979) {
        $this.isMobile = false
        $this.deviceModel = 'pc'
      }else if ($this.deviceModel === 'pc' && $(window).width() <= 979){
        $this.isMobile = true
        $this.deviceModel = 'mb'
      }  
    },
    init: function(){
      this.banner = bannerData
			this.getDevice()
			this.isYoutube = this.defLangx === 'cn' ? false : true
    }
  },
	computed:{
		...mapGetters({
      defLangx: 'defLangx',
    }),
	},
  mounted(){
		this.init()
    if(!this.isYoutube){
			$.getScript("//player.youku.com/jsapi", function() {
				new YKU.Player('youkuplayer',{
					styleid: '0',
					client_id: 'a927dc23e5555ef2',
					vid: 'XMjgzNTgwMjYyOA',
					newPlayer: true
				});
			});
		}
		this.$store.dispatch('setLoadshow',false)
	},
	beforeDestroy(){
		this.$store.dispatch('setLoadshow',true)
	}
}
</script>
<style lang="sass">
  @import '@css/g2e2017.sass'
</style>